/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoalDto
 */
export interface GoalDto {
    /**
     * 
     * @type {number}
     * @memberof GoalDto
     */
    yearWeek?: number;
    /**
     * 
     * @type {number}
     * @memberof GoalDto
     */
    value?: number;
}

/**
 * Check if a given object implements the GoalDto interface.
 */
export function instanceOfGoalDto(value: object): value is GoalDto {
    return true;
}

export function GoalDtoFromJSON(json: any): GoalDto {
    return GoalDtoFromJSONTyped(json, false);
}

export function GoalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'yearWeek': json['yearWeek'] == null ? undefined : json['yearWeek'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function GoalDtoToJSON(json: any): GoalDto {
    return GoalDtoToJSONTyped(json, false);
}

export function GoalDtoToJSONTyped(value?: GoalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'yearWeek': value['yearWeek'],
        'value': value['value'],
    };
}

